// import React, { useState } from "react";
// import "../styles/AnfrageForm.css";

// const AnfrageForm = () => {
//     const [formData, setFormData] = useState({
//         vorname: "",
//         nachname: "",
//         email: "",
//         telefon: "",
//         frage: "",
//     });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const response = await fetch(
//                 "https://admin.thirsty-shtern.91-151-16-181.plesk.page/items/Anfragen",
//                 {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json",
//                     },
//                     body: JSON.stringify(formData),
//                 }
//             );

//             if (response.ok) {
//                 alert("Formular erfolgreich gesendet!");
//                 setFormData({
//                     vorname: "",
//                     nachname: "",
//                     email: "",
//                     telefon: "",
//                     frage: "",
//                 });
//             } else {
//                 alert("Fehler beim Senden des Formulars.");
//             }
//         } catch (error) {
//             alert("Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal.");
//         }
//     };

//     return (
//         <div id="kontakt" className="app-wrapper container">
//             <h2 className="formTitle">Hast du Fragen? Schreib uns!</h2>
//             <p>Egal, ob es um deine Ausbildung, Kurse oder ein individuelles Angebot geht – wir sind für dich da! Füll einfach das Formular aus und wir melden uns so schnell wie möglich bei dir.</p>
//             <form onSubmit={handleSubmit} className="form">
//                 <label className="label">
//                     Vorname
//                     <input
//                         type="text"
//                         name="vorname"
//                         value={formData.vorname}
//                         onChange={handleChange}
//                         required
//                         className="input"
//                     />
//                 </label>
//                 <label className="label">
//                     Nachname
//                     <input
//                         type="text"
//                         name="nachname"
//                         value={formData.nachname}
//                         onChange={handleChange}
//                         required
//                         className="input"
//                     />
//                 </label>
//                 <label className="label">
//                     E-Mail
//                     <input
//                         type="email"
//                         name="email"
//                         value={formData.mail}
//                         onChange={handleChange}
//                         required
//                         className="input"
//                     />
//                 </label>
//                 <label className="label">
//                     Telefon
//                     <input
//                         type="tel"
//                         name="telefon"
//                         value={formData.telefon}
//                         onChange={handleChange}
//                         required
//                         className="input"
//                     />
//                 </label>
//                 <label className="label">
//                     Frage
//                     <textarea
//                         name="frage"
//                         value={formData.frage}
//                         onChange={handleChange}
//                         required
//                         className="textarea"
//                     />
//                 </label>
//                 <button type="submit" className="button">
//                     senden
//                 </button>
//             </form>
//         </div>
//     );
// };

// export default AnfrageForm;


import React, { useState, useEffect } from "react";
import "../styles/AnfrageForm.css";

const AnfrageForm = ({ setMessage }) => {
    const [formData, setFormData] = useState({
        vorname: "",
        nachname: "",
        email: "",
        telefon: "",
        frage: "",
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(
                "https://admin.thirsty-shtern.91-151-16-181.plesk.page/items/Anfragen",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }
            );

            if (response.ok) {
                setMessage({ text: "Formular erfolgreich gesendet!", type: "success" });
                setFormData({ vorname: "", nachname: "", email: "", telefon: "", frage: "" });
            } else {
                setMessage({ text: "Fehler beim Senden des Formulars.", type: "error" });
            }
        } catch (error) {
            setMessage({ text: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal.", type: "error" });
        }

        // setTimeout(() => {
        //     setMessage(null);
        // }, 3000);
    };

    return (
        <div id="kontakt" className="anfrage-container">
            <div className="kontakt-info">
                <h2 className="formTitle">Hast du Fragen? <span>Schreib uns!</span></h2>
                <p>
                    Egal, ob es um deine Ausbildung, Kurse oder ein individuelles Angebot geht – wir sind
                    für dich da! Füll einfach das Formular aus und wir melden uns so schnell wie möglich bei
                    dir.
                </p>
            </div>
            {/* {message && (
                <div className={`message-box ${message.type}`}>
                    {message.text}
                </div>
            )} */}
            <form onSubmit={handleSubmit} className="form">
                <label className="label">
                    Vorname
                    <input
                        type="text"
                        name="vorname"
                        value={formData.vorname}
                        onChange={handleChange}
                        required
                        className="input"
                    />
                </label>
                <label className="label">
                    Nachname
                    <input
                        type="text"
                        name="nachname"
                        value={formData.nachname}
                        onChange={handleChange}
                        required
                        className="input"
                    />
                </label>
                <label className="label">
                    E-Mail
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="input"
                    />
                </label>
                <label className="label">
                    Telefon
                    <input
                        type="tel"
                        name="telefon"
                        value={formData.telefon}
                        onChange={handleChange}
                        required
                        className="input"
                    />
                </label>
                <label className="label">
                    Frage
                    <textarea
                        name="frage"
                        value={formData.frage}
                        onChange={handleChange}
                        required
                        className="textarea"
                    />
                </label>
                <button type="submit" className="button">
                    senden
                </button>
            </form>
        </div>
    );
};

export default AnfrageForm;
